// apps/frontend/src/utils/sanitizeHtml.js
// Unica configurazione DOMPurify per i messaggi chat (widget e anteprima editor):
// stessa sanitizzazione ovunque → l'anteprima è fedele alla resa reale.
import DOMPurifyLib from 'dompurify';

// DOMPurify (ESM/CJS) può essere già un'istanza (browser) oppure una factory
// da invocare con un window (SSR, jsdom). Normalizziamo una volta sola.
const purify = (() => {
  if (typeof DOMPurifyLib === 'function') {
    // factory: invochiamo con la window corrente (browser o jsdom)
    const win = typeof window !== 'undefined' ? window : null;
    return win ? DOMPurifyLib(win) : null;
  }
  // già istanza (browser con bundler)
  return DOMPurifyLib;
})();

if (purify) {
  // target è escluso dalla allow-list di default di DOMPurify: lo riammettiamo
  // e forziamo rel="noopener noreferrer" sui link con target (anti tab-napping).
  purify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.hasAttribute('target')) {
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
}

export function sanitizeHtml(content) {
  if (!purify) return '';
  return purify.sanitize(content || '', { ADD_ATTR: ['target'] });
}
